import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Card, DatePicker, Row, Col } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import { FaRupeeSign, FaUserClock, FaSignInAlt } from "react-icons/fa";
const { RangePicker } = DatePicker

class AllUserLoginHistory extends Component {

  state = {
    id: '',
    total: 0,
    time: {
      from: moment().startOf('month').toDate(),
      to: moment().endOf('month').toDate(),
    },
    paidLeaves: 0,
  }
  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1],
        },
      },
      () => {
        this.reload();
      }
    );
    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };
  onOk = value => {
    this.reload()
  }
  reload = () => {
    this.table.current.reload();
    // this.tableOverallReport.current.reload();
  };
  apiRequest = params => {
    return new Promise(async resolve => {
      if (this.state.time && this.state.time.from) {
        params.time = this.state.time;
      }
      this.setState({ exportParams: params })
      let data = await Request.getUserAttendance({
        ...params
      });
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  apiRequestOverAllReport = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let localUser = JSON.parse(localStorage.getItem('user'))
      params.userId = localUser._id;
      if (this.state.time && this.state.time.from) {
        params.time = this.state.time;
      }
      let data = await Request.getUserOverallReport({
        ...params
      });
      this.setState({ paidLeaves: data.paidLeaves })
      resolve(data)
    })
  }

  componentWillMount() {
  }

  async componentDidMount() {

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.tableOverallReport = React.createRef()
  }

  getSpecificDayCount = (y, m, countDay = 0) => {
    var days = new Date(y, m, 0).getDate();
    var sundays = [(8 - (new Date(m + '/01/' + y).getDay())) % 7];
    for (var i = sundays[0] + 7; i < days; i += 7) {
      sundays.push(i);
    }
    return sundays;
  }

  render() {
    const { total, defaultPageSize, paidLeaves } = this.state;

    const columns = [
      {
        title: 'Attendance Date',
        key: 'userAttendanceDate',
        render: (text, record) => (
          <div> {moment(record._id.attendanceDate).format('DD-MM-YYYY')} </div>
        )
      },
      {
        title: 'Total Worked',
        key: 'totalHours',
        render: (text, record) => (
          <div> Hours:- {text} </div>
        )
      },
      {
        title: 'Total Login Attemtps',
        key: 'totalAttempts',
        render: (text, record) => (
          <div> Count:- {text} </div>
        )
      },
      {
        title: 'Logs (Login - Logout)',
        key: 'logs',
        render: (text, record) => {
          const { loginAt } = record;
          let loginHtml = loginAt.join(' <br /> ');
          return (
            <div dangerouslySetInnerHTML={{ __html: loginHtml }}></div>
          )
        }
      }
    ]

    let years = [];
    let currentYear = moment().format('Y');
    for (let yr = 2023; yr <= currentYear; yr++) {
      years.push({
        key: yr,
        value: yr
      })
    }

    let extraDays = this.getSpecificDayCount(moment().format('Y'), moment().format('MM'));
    let extraHours = extraDays.length * 8;

    const columnOverallReport = [
      {
        title: 'Total Worked Hours',
        key: 'totalHours',
        render: (text, record) => (
          <div><FaUserClock /> {text} </div>
        )
      },
      {
        title: 'Extra Hours',
        key: 'extraHours',
        render: (text, record) => (
          <div>Sunday:- {extraHours} + {paidLeaves > 0 ? 'Holiday:- ' + (paidLeaves * 8) : ''} Paid Leave:- 8 </div>
        )
      },
      {
        title: 'Total Hours / Days',
        key: 'hoursDays',
        dataIndex: 'hoursDays',
        render: (text, record) => (
          <div> {(parseFloat(record.totalHours) + extraHours + (paidLeaves > 0 ? (paidLeaves * 8) : 0) + 8)} / {((parseFloat(record.totalHours) + extraHours + (paidLeaves > 0 ? (paidLeaves * 8) : 0) + 8) / 8).toFixed(1)} </div>
        )
      },
      {
        title: 'Total Salary',
        key: 'staffSalary',
        dataIndex: 'staffSalary',
        render: (text, record) => (
          <div> <FaRupeeSign /> {parseFloat(record.user.staffSalary) * (parseFloat(record.totalHours) + extraHours + (paidLeaves > 0 ? (paidLeaves * 8) : 0) + 8)} </div>
        )
      },
      {
        title: 'Total Login Attemtps',
        key: 'totalAttempts',
        render: (text, record) => (
          <div> <FaSignInAlt /> {text} </div>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={` Login History: ${total} `}>
        <Card bordered={true}>
          <Row>
            <Col span={8}>
              <label>Search By Date</label>
              <RangePicker
                allowClear={false}
                showTime={{ format: 'HH:mm' }}
                defaultValue={
                  [moment(this.state.time.from), moment(this.state.time.to)]
                }
                format="YYYY-MM-DD HH:mm"
                placeholder={['Start Time', 'End Time']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
          </Row>
        </Card>
        {/* <Card bordered={true}>
          <TableComp
            ref={this.tableOverallReport}
            columns={columnOverallReport}
            apiRequest={this.apiRequestOverAllReport}
            extraProps={{scroll: {x: 900}}}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card> */}
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllUserLoginHistory
